import { render, staticRenderFns } from "./DataConfirmationStep.vue?vue&type=template&id=f5d75be8&scoped=true&"
import script from "./DataConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./DataConfirmationStep.vue?vue&type=script&lang=js&"
import style0 from "./DataConfirmationStep.vue?vue&type=style&index=0&id=f5d75be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d75be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5d75be8')) {
      api.createRecord('f5d75be8', component.options)
    } else {
      api.reload('f5d75be8', component.options)
    }
    module.hot.accept("./DataConfirmationStep.vue?vue&type=template&id=f5d75be8&scoped=true&", function () {
      api.rerender('f5d75be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/DataConfirmationStep.vue"
export default component.exports